import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
    grid: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '100%',
        paddingRight: 3,
        position: 'relative',
    },
    gridLast: {
        height: '90%',
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderRightColor: 'rgb(204,214,228)',
    }
});

const initialValue = -10;
const endValue = 18;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 2) {
    finalArray.push({ label: n });
}

const TableGridBars = () => {
    return (
        <View style={styles.grid}>
            {finalArray.map((item, index) => {
                return (
                    <View
                        key={index}
                        style={{
                            width: '6.66%',
                            height: '90%',
                            borderLeftStyle: 'solid',
                            borderLeftColor: 'rgb(204,214,228)',
                            borderLeftWidth: 1,
                        }}
                    ></View>
                );
            })}
            <View style={styles.gridLast}></View>
        </View>
    )
}

export default TableGridBars